<script setup lang="ts">
import {router} from "@inertiajs/vue3";

interface Props {
    href: string
    class?: string
}

const props = defineProps<Props>()

const goTo = () => {
    router.visit(props.href)
}
</script>

<template>
    <a
        class="underline-hover"
        :class="props.class"
        @click="goTo"
    ><slot /></a>
</template>

<style scoped>
.underline-hover:hover {
    text-decoration: underline;
    cursor: pointer;
    color: #0b63f3 !important;
}
</style>
